import { Component } from '@theme/component'

/**
 * A custom element that manages product suggested usage display with taste selection.
 *
 * @extends Component
 */
export class ProductSuggestedUsageComponent extends Component {
  /** @type {string} */
  #currentTaste = ''

  connectedCallback() {
    super.connectedCallback()

    const tasteSelect = this.querySelector('select[name="properties[usage_taste]"]')
    if (tasteSelect instanceof HTMLSelectElement) {
      this.#currentTaste = tasteSelect.value
    }

    this.#setupEventListeners()
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.#removeEventListeners()
  }

  #setupEventListeners() {
    const tasteSelect = this.querySelector('select[name="properties[usage_taste]"]')
    if (tasteSelect) {
      tasteSelect.addEventListener('change', this.#handleTasteChange)
    }
  }

  #removeEventListeners() {
    const tasteSelect = this.querySelector('select[name="properties[usage_taste]"]')
    if (tasteSelect) {
      tasteSelect.removeEventListener('change', this.#handleTasteChange)
    }
  }

  /**
   * @param {Event} event
   */
  #handleTasteChange = (event) => {
    const tasteSelect = /** @type {HTMLSelectElement} */ (event.target)
    if (!tasteSelect) return

    this.#currentTaste = tasteSelect.value

    this.querySelectorAll('.suggested-usage-text').forEach((usageText) => {
      if (!(usageText instanceof HTMLElement)) {
        return
      }

      usageText.style.display =
        usageText.dataset.tasteOptionId === this.#currentTaste ? 'block' : 'none'
    })
  }
}

customElements.define('product-suggested-usage', ProductSuggestedUsageComponent)
